// extracted by mini-css-extract-plugin
module.exports = {"header":"UserStatusSitesList-header-10ffbec83e3ca0f144ee769213d67c2e"};